export const NoResultsList = ({
  width = 16,
  height = 16,
  viewBox = '0 0 16 16',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      <path
        d="M10.6667 3.33398H2M7.33333 8.00065H2M10.6667 12.6673H2M14 8.00065H10"
        stroke="#0E0E12"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
